/**
 * Zendesk Support integration endpoints (Help Center SSO + Messenger chat).
 *
 * Used only when the `support-zendesk` release flag is ON. The native
 * `/api/support` ticketing surfaces stay mounted but unused in that mode.
 */

import { apiGet, apiPost } from '@/api/client';

/** Response shape for both Zendesk JWT minting endpoints. */
export type ZendeskJwtResponse = {
  jwt: string;
};

/**
 * Mint a Help Center SSO JWT and (server-side) sync the Zendesk end-user.
 *
 * @param returnTo - Absolute Help Center URL the browser should land on after SSO.
 */
export function zendeskSsoToken(returnTo: string): Promise<ZendeskJwtResponse> {
  return apiPost<ZendeskJwtResponse>('/support/zendesk/sso-token', { returnTo });
}

/**
 * Mint a Messenger chat JWT for `zE('messenger', 'loginUser', …)`.
 */
export function zendeskChatToken(): Promise<ZendeskJwtResponse> {
  return apiGet<ZendeskJwtResponse>('/support/zendesk/chat-token');
}
